<template>
  <footer class="bg-white" aria-labelledby="footer-heading">
    <h2 id="footer-heading" class="sr-only">Footer</h2>
    <div class="max-w-7xl mx-auto py-12 pb-8 px-4 sm:px-6 lg:px-8">
      <div class="grid md:grid-cols-2 gap-6">
        <div>
          <img class="h-9 w-auto" src="@/assets/logo.svg" alt="H.E.L.P.M.E." />
          <img
            class="h-28 mt-6"
            src="@/assets/media/Presenter-Black.png"
            alt="World Congress"
          />
        </div>
        <div>
          <h3 class="mb-3">Contact Us</h3>
          <div class="space-y-2">
            <a
              href="tel:+416-435-4563"
              class="block with-underline w-max hover:text-accent"
              ><strong>Phone:</strong> 416-435-4563
            </a>
            <a
              href="mailto:lisa@helpmeOHS.com"
              class="block with-underline w-max hover:text-accent"
              ><strong>Email:</strong> lisa@helpmeOHS.com</a
            >
            <a title="LinkedIn"
              href="https://www.linkedin.com/in/lisa-may-c-7383a9147/" target="_blank"
              class="block with-underline w-max hover:text-accent" style="margin-top: 25px;"
              >
			  <svg viewBox="0 0 30 30" width="30" height="30" stroke="currentColor" stroke-width="0" fill="#999" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1 inline"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
				
			</a>
          </div>
        </div>
      </div>
      <div
        class="
          mt-8
          pt-8
          border-t border-gray-200
          md:flex md:items-center md:justify-between grid md:grid-cols-2
        "
      >
        <p class="text-base text-gray-400">
          &copy; Copyright {{ new Date().getFullYear() }} H.E.L.P. M.E.
        </p>
		<a
              href="https://airwhistle.com" target="_blank"
              class="block with-underline w-max hover:text-accent mt-2 opacity-50 hover:opacity-70"
              >
			  <svg alt="built by Air Whistle Media" xmlns="http://www.w3.org/2000/svg" version="1.2" baseProfile="tiny-ps" viewBox="0 0 121 82" width="30" height="30"><g><g><path class="shp0" d="M2.3 18.2C1.5 18.2 1.2 18.4 1.1 18.5C1.1 18.5 0.9 18.6 0.9 19C0.9 22.7 9.5 31.4 12.2 31.4L41 31.4L47.2 18.2L2.3 18.2Z"/><path class="shp0" d="M12.9 33.9C12.1 33.9 11.8 34.1 11.7 34.2C11.7 34.2 11.5 34.3 11.5 34.7C11.5 38.4 20.1 47.1 22.9 47.1L33.7 47.1L39.9 33.9L12.9 33.9L12.9 33.9Z"/><path class="shp0" d="M24.4 49.6C23.9 49.6 23.2 49.7 23 50.1C22.6 51.5 24.9 55.4 28.2 58.7L32.4 49.7L24.4 49.7L24.4 49.6Z"/><path class="shp0" d="M108.1 31.4C110.9 31.4 119.5 22.7 119.5 19C119.5 18.6 119.4 18.5 119.3 18.5C119.2 18.4 118.9 18.2 118.1 18.2L73.1 18.2L79 31.4L108.1 31.4Z"/><path class="shp0" d="M97.5 47.1C100.3 47.1 108.8 38.4 108.8 34.7C108.8 34.3 108.7 34.2 108.6 34.2C108.5 34.1 108.2 33.9 107.4 33.9L80.2 33.9L86.1 47.1L97.5 47.1L97.5 47.1Z"/><path class="shp0" d="M97.2 50.1C97.1 49.7 96.3 49.6 95.8 49.6L87.2 49.6L91.5 59.1C95.1 55.8 97.7 51.5 97.2 50.1Z"/><path fill-rule="evenodd" class="shp0" d="M95 79.2L80.2 79.2L73.1 62.8L46.4 62.8L38.9 79.2L24.3 79.2L60.3 1.9L95 79.2ZM52.2 49.9L67.5 49.9L60 32.7L52.2 49.9Z"/></g><g/></g></svg>
            </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { navigation } from "@/data";

export default {
  setup() {
    return { navigation };
  },
};
</script>
